import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); // auto logout if 401 response returned from API
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Insurance Services --------------------
function addInsurance(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/addinsurance`;
  return apiFetch(url, requestOptions);
}

function modifyInsurance(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/changeinsurance?id=${data.id}`;
  return apiFetch(url, requestOptions);
}

function getInsuranceMaster() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/insurancedetails`;
  return apiFetch(url, requestOptions);
}

function deleteInsurance(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/deleteinsurance?id=${data.id}`;
  return apiFetch(url, requestOptions);
}

// -------------------- TPA Services --------------------
function getTpaMaster() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/v1/tpadetails`;
  return apiFetch(url, requestOptions);
}

function addTpaMaster(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/addtpa`;
  return apiFetch(url, requestOptions);
}

function modifyTpa(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/changetpa?id=${data.id}`;
  return apiFetch(url, requestOptions);
}

function deleteTpa(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/removetpa?id=${data.id}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const insuranceServices = {
  logout,
  handleResponse,
  addInsurance,
  modifyInsurance,
  getInsuranceMaster,
  deleteInsurance,
  getTpaMaster,
  addTpaMaster,
  modifyTpa,
  deleteTpa,
};

export default insuranceServices;
